import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { DailyAggregate } from '@etiquetachef/types';
import { formatInt, formatYyyymmddDisplay } from '../formatters';
import { BiTimeChart } from './BiTimeChart';

/**
 * Membros criados por dia (`members.createdToday` do agregado diário).
 *
 * Origem: sem issue — commit 85642b993, 2026-05-04 15:56 +0200.
 * Usado por: `FinanceDashboardPage` (rota `/dashboard/finance`, `apps/admin`).
 *
 * Histórico:
 *  - 2026-10-10 14:40 +0200 — (#798) cabeçalho padrão (#796).
 */
export function UsersChart({ series }: { series: readonly DailyAggregate[] }): React.JSX.Element {
  const { t } = useTranslation();
  const data = series.map((d) => ({
    x: formatYyyymmddDisplay(d.yyyymmdd),
    y: d.members.createdToday,
  }));
  return (
    <BiTimeChart
      title={t('finance.charts.users')}
      type="bar"
      data={data}
      color="#0ea5e9"
      valueFormatter={(v): string => formatInt(v)}
    />
  );
}
